import React from "react";
import Grid from "@material-ui/core/Grid";

import { Typography } from "@material-ui/core";

export default function Main() {
  return (
    <div
      style={{ maxWidth: "1100px", textAlign: "center", marginTop: "100px" }}
      //maxWidth: "1100px"
    >
      <Grid item container justify="center" alignItems="center">
        <Grid item sm={10} md={5}>
          <img
            src="image/main.png"
            alt="main"
            height="400px"
            width="200px"
          ></img>
        </Grid>
        <Grid item xs={11} sm={8} md={5}>
          <Typography variant="h3">
            A Truely Indian Camscanner Alternative.
          </Typography>
          <Typography variant="inherit">
            Best Indian App That Gives You Best Quality Scanned Images In Your
            Device Quickly.
          </Typography>
          <div>
            <a href="https://play.google.com/store/apps/details?id=com.solotech.indiadocscanner">
              <img
                src="image/play-store.png"
                style={{ borderRadius: "40%" }}
                alt="Play Store"
                width="170px"
                height="80px"
              />
            </a>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
